import { render } from "./CZAccrualsGas.vue?vue&type=template&id=b5bb75ce&scoped=true&ts=true"
import script from "./CZAccrualsGas.vue?vue&type=script&lang=ts"
export * from "./CZAccrualsGas.vue?vue&type=script&lang=ts"

import "./CZAccrualsGas.vue?vue&type=style&index=0&id=b5bb75ce&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bb75ce"]])

export default __exports__